// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const Division = t.list(KeyValuePair, 'division');

export const getDefaultState = () => new Division([]);

export default Division;




// WEBPACK FOOTER //
// ./src/product/dealer-search/state/division.js